module.exports = __webpack_public_path__ + "static/media/we_found_car_once.20ad1b3d.gif";